import { IUserOwnTractorDetail } from '../../../interfaces/OwnTractor.interfaces';
import { customAxios } from '../../common/customAxios';
import { usersOwnTractorsApiUrl } from './getUsersOwnTractors';

export interface IGetUsersOwnTractorByIdParams {
  tractorId: string;
}

export const getUsersOwnTractorById = ({
  tractorId,
}: IGetUsersOwnTractorByIdParams): Promise<IUserOwnTractorDetail> => {
  return customAxios.get(`${usersOwnTractorsApiUrl}/${tractorId}`);
};
